import React from "react";
import Images from "../data/Images";

const Training = () => {
  return (
    <div className="text-gray-800 font-sans">
      <section className="bg-red-800 text-white py-16">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h1 className="text-5xl font-extrabold mb-6">Upcoming Services</h1>
          <h1 className="text-3xl font-extrabold mb-6">
            Basic Security Training
          </h1>
          <p className="text-lg max-w-3xl mx-auto">
            At <span className="font-semibold">Newwaysecurity</span>, we make it
            easy to obtain your Ontario Security Guard License. With expert
            trainers, flexible programs, and full support—including free course
            retakes—we’re here to help you pass the Ministry test confidently.
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 py-16 space-y-16">
        {[
          {
            title:
              "In-Class Ontario Basic Security Guard Training (BST) – $175",
            text: [
              "Our 40-hour in-class BST program runs weekly, Monday to Friday (8 AM – 5 PM) at our Toronto Head Office. It’s ideal for learners who prefer face-to-face instruction.",
              "You’ll benefit from interactive sessions, personal guidance, and a structured environment that helps you stay focused and succeed.",
            ],
            image: Images.ontario,
            reverse: false,
            link: "#",
          },
          {
            title: "Online Ontario Basic Security Guard Training (BST) – $175",
            text: [
              "Perfect for busy individuals, our self-paced online BST program includes 10 training modules (approx. 32 hours). Learn anytime, from anywhere.",
              "Complete an additional 8-hour in-person Emergency First Aid / CPR-C session to finalize your training.",
            ],
            image: Images.onlineclass,
            reverse: true,
            link: "#",
          },
          {
            title: "Emergency First Aid / CPR-C",
            text: [
              "Our blended Emergency First Aid & CPR-C course combines online theory with in-person training at Toronto or Mississauga locations.",
              "Already certified? Present your valid Emergency First Aid certificate upon BST registration to bypass this step.",
            ],
            image: Images.firstaid,
            reverse: false,
            link: null,
          },
          {
            title: "Ministry Test & License Support",
            text: [
              "After completing your training, we assist you in scheduling the Ministry test and help with the license application process.",
              "Our team ensures everything is straightforward, so you can focus on your career.",
            ],
            image: Images.ministry,
            reverse: true,
            link: null,
          },
          {
            title: "Onboarding for Success",
            text: [
              "We invest in your long-term success through structured onboarding programs and fast, effective skill-building.",
              "You’ll gain hands-on training, scenario practice, and ongoing coaching to help you excel in real-world security roles.",
            ],
            image: Images.oboarding,
            reverse: false,
            link: null,
          },
          {
            title: "Specialized Training by Sector",
            text: [
              "Each client has unique needs—so our team receives specialized training for residential, commercial, and institutional sites.",
              "From conflict resolution to safety protocols, you’ll be fully prepared to provide exceptional service wherever you’re placed.",
            ],
            image: Images.specialized,
            reverse: true,
            link: null,
          },
        ].map((item, index) => (
          <div
            key={index}
            className={`flex flex-col ${
              item.reverse ? "md:flex-row-reverse" : "md:flex-row"
            } items-center bg-white rounded-2xl shadow-lg overflow-hidden`}
          >
            <img
              src={item.image}
              alt={item.title}
              className="w-full md:w-1/2 h-64 object-cover"
            />
            <div className="p-8 md:w-1/2 space-y-4">
              <h2 className="text-2xl font-bold text-red-800">{item.title}</h2>
              {item.text.map((t, i) => (
                <p key={i} className="text-gray-700">
                  {t}
                </p>
              ))}
              {item.link && (
                <a
                  href={item.link}
                  className="inline-block mt-4 bg-red-800 text-white px-6 py-2 rounded-full hover:bg-red-900 transition"
                >
                  Register & Pay for Class
                </a>
              )}
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default Training;
